// OBT F3-D — Park varlık geçmişi ağacı (§6): varlıklar + kronolojik kayıtlar.
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MapPin, Plus } from 'lucide-react';
import { ObtEmptyState } from '../ObtStates';
import { AssetTypeBadge, WarrantyBadge } from './MemoryBadges';
import AssetRecordCard from './AssetRecordCard';
import { ASSET_TYPE_LABELS, memoryLabel } from './memoryEnums';

/**
 * @param {object} props
 * @param {Array} props.assets  ParkAssetHistoryOut.assets ([{asset, records}])
 * @param {boolean} [props.canEdit]
 * @param {(asset) => void} [props.onAddRecord]
 * @param {boolean} [props.showPhotos]
 */
export default function AssetHistoryTree({ assets, canEdit = false, onAddRecord, showPhotos = true }) {
  const list = Array.isArray(assets) ? assets : [];
  if (list.length === 0) {
    return (
      <ObtEmptyState
        title="Bu parkta kayıtlı varlık yok"
        description="Kurumsal hafıza için bir varlık ekleyin."
      />
    );
  }
  return (
    <div className="space-y-3">
      {list.map(({ asset, records }) => (
        <Card key={String(asset.asset_id)}>
          <CardContent className="space-y-2 p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="flex flex-wrap items-center gap-2">
                <MapPin className="h-4 w-4 text-gray-500" aria-hidden="true" />
                <span className="text-sm font-semibold text-gray-900">
                  {asset.name || memoryLabel(ASSET_TYPE_LABELS, asset.asset_type)}
                </span>
                <AssetTypeBadge type={asset.asset_type} />
                <WarrantyBadge status={asset.warranty_status} />
              </div>
              {canEdit && onAddRecord && (
                <Button size="sm" variant="outline" onClick={() => onAddRecord(asset)}>
                  <Plus className="mr-1 h-4 w-4" aria-hidden="true" /> Kayıt Ekle
                </Button>
              )}
            </div>
            {(Array.isArray(records) ? records : []).length === 0 ? (
              <p className="pl-6 text-xs text-gray-500">Henüz geçmiş kaydı yok.</p>
            ) : (
              <div className="space-y-2 pl-1">
                {records.map((r) => (
                  <AssetRecordCard key={String(r.record_id)} record={r} showPhotos={showPhotos} />
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
